export default __webpack_public_path__ + "static/media/ce-mdh.4a034607.png";